import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import {
  UncontrolledTooltip,
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row
} from 'reactstrap'

import CustomPagination from 'components/Pagination'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import PageTitle from 'components/Title/PageTitle'
import Moment from 'moment'
import SearchForm from 'components/SearchForm'

import FairsHOC from './actions'
import FairsForm from './Form'

import Lang from 'Lang/General'

const Fairs = props => {

  useEffect(() => {
    props.getCountries()
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangeFairsHOC('subscribedPackage', tmpIndex > -1)
  }, [])

  useEffect(() => {
    props.getFairs({
      filter:{"client_id": props.data.selectCenterReducer.selectedCenter.center.client_id},
      page: 1,
      is_paginated: true,
    })
    props.onChangeFairsHOC('defaultQuery', {
      filter:{"client_id": props.data.selectCenterReducer.selectedCenter.center.client_id},
      page: 1,
      is_paginated: true,
    })
  }, [])

  useEffect(() => {
    if (!props.showEditModal) {
      props.onChangeFairsHOC('selectedFairs', {})
      props.onChangeFairsHOC('fairErrorMessage', {})
    }
  }, [props.showEditModal])
  
  useEffect(() => {
    if (!props.showCreateFairsl) {
      props.onChangeFairsHOC('fairErrorMessage', {})
    }
  }, [props.showCreateFairs])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  const renderCreateFairsForm = () => (
    <Modal isOpen={props.showCreateFairs} size='xl' >
      <FairsForm
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        data={props.data}
        mode={'create'}
        countries={props.countries}
        onSubmit={props.createFairs}
        onClose={() => props.onChangeFairsHOC('showCreateFairs', false)}
        fairErrorMessage={props.fairErrorMessage}
      />
      {props.onLoadFairsHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderUpdateFairsForm = () => (
    <Modal isOpen={props.showEditModal} size='xl' >
      <FairsForm
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        mode={'edit'}
        countries={props.countries}
        selectedFairs={props.selectedFairs}
        data={props.data}
        onSubmit={props.updateFairs}
        onClose={() => props.onChangeFairsHOC('showEditModal', false)}
        fairErrorMessage={props.fairErrorMessage}
      />
      {props.onLoadFairsHOC && <LoadingOverlay />}
    </Modal>
  )

  return (
    <>
      <PageTitle
        heading={Lang['FAIRS'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-speaker icon-gradient bg-happy-itmeo"
        buttons={[
          {
            buttonText: Lang['CREATE_FAIR'][props.data.languageReducer.userSettings.admin_panel_language],
            onClick: () => props.onChangeFairsHOC('showCreateFairs', true),
            display: permissionHandle('is_create')
          }
        ]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <SearchForm
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangeFairsHOC}
                defaultQuery={props.defaultQuery}
                getListAPI={val => props.getFairs({
                  ... val,
                  filter : {
                    ... val.filter,
                    "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id
                  }
                })}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <ReactTable
                  defaultPageSize={10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.fairs}
                  columns={[
                    {
                      Header: Lang['TITLE'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'title'
                    },
                    {
                      Header: Lang['START'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'start_at',
                      Cell: row => Moment(row.original.start_date).format('YYYY-MM-DD')
                    },
                    {
                      Header: Lang['END'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'end_at',
                      Cell: row => Moment(row.original.end_date).format('YYYY-MM-DD')
                    },
                    {
                      Header: Lang['STATUS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'status'
                    },
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: row => (
                        <>
                          {
                            permissionHandle('is_update') && (
                              <>
                                <Button
                                  className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                                  color='primary'
                                  id={`portal-user-${ row.original.id }-edit-btn`}
                                  onClick={() => {
                                    props.onChangeFairsHOC('selectedFairs', row.original)
                                    props.onChangeFairsHOC('showEditModal', true)
                                  }} >
                                  <i className="pe-7s-pen btn-icon-wrapper" />
                                </Button>
                                <UncontrolledTooltip
                                  target={ `portal-user-${ row.original.id }-edit-btn` }
                                  placement="top">
                                  { Lang[ 'EDIT' ][props.data.languageReducer.userSettings.admin_panel_language ] }
                                </UncontrolledTooltip>
                                <Button
                                  className="mb-2 mt-2 btn-icon btn-icon-only"
                                  color={ !row.original.is_active ? 'success' : 'danger' }
                                  onClick={() => {
                                    props.updateFairs({
                                      ...row.original,
                                      is_active: !row.original.is_active
                                    })
                                  }}>
                                  {Lang[ row.original.is_active ? 'ARCHIVE' : 'ACTIVE' ][props.data.languageReducer.userSettings.admin_panel_language]}
                                </Button>
                              </>
                            )
                          }
                        </>
                      )
                    }
                  ]}
                />
                <CustomPagination
                  meta={props.fairsMeta}
                  onChangePage={ val => props.getFairs({
                    ... props.query,
                    page: val
                  })}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      {renderCreateFairsForm()}
      {renderUpdateFairsForm()}
      {props.onLoadFairsHOC && <LoadingOverlay />}
    </>
  )
}

export default FairsHOC(Fairs)
